/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type GetWalletBalanceResponseMetadataType = typeof GetWalletBalanceResponseMetadataType[keyof typeof GetWalletBalanceResponseMetadataType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetWalletBalanceResponseMetadataType = {
  digital: 'digital',
  jurisdiction: 'jurisdiction',
  commodity: 'commodity',
  securities: 'securities',
  insurance: 'insurance',
  alternative: 'alternative',
  commission: 'commission',
  operation: 'operation',
  subaccount: 'subaccount',
} as const;
